"use client";
import { Center, CenterProps } from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import { LoadingAnimation, LoadingAnimationProps } from "./loading-animation";

export interface LoadWithChildProps
  extends PropsWithChildren<LoadingAnimationProps> {
  containerSx?: CenterProps;
}
export default function LoadWithChild({
  containerSx,
  children,
  ...props
}: LoadWithChildProps) {
  return (
    <Center
      flexDirection="column"
      justifyContent="center"
      align="center"
      textAlign="center"
      {...containerSx}
    >
      <>
        <LoadingAnimation {...props} />
        {children}
      </>
    </Center>
  );
}
